/* eslint-disable consistent-return, no-param-reassign */
import Slider from '../Slider';
import { slideUp, slideDown } from '../../utils/index';
import './style.scss';

class PerfomanceSlider extends Slider {
  calculateStageWidth() {
    return (3 * this.itemWidth + this.margin * 2) - 40;
  }

  run() {
    this.getResponsiveProps();

    if (this.state.inactive) return false;

    if (!this.state.initialized) {
      this.preInit();
      this.generateNav();
      this.attachSwipeHandlers();
      this.generateDots();
      this.state.current = 0;
    }

    this.setStageWidth();

    if (!this.state.initialized) {
      this.changeSlide(this.state.current);
    }

    this.setStageHeight();

    if (!this.state.initialized) {
      this.init();
    }
  }

  setNavButtonsPosition() {
    if (this.getWindowWidth() < 1024 && this.isSetNavButtonsPosition) {
      this.prevBtn.style.left = `${(this.selector.offsetWidth / 2) - this.prevBtn.offsetWidth - this.itemWidth / 2 + this.prevBtn.offsetWidth / 2}px`;

      this.nextBtn.style.right = `${(this.selector.offsetWidth / 2) - this.nextBtn.offsetWidth - this.itemWidth / 2 + this.nextBtn.offsetWidth / 2}px`;
    } else {
      this.prevBtn.style.left = '';
      this.nextBtn.style.right = '';
    }
  }

  onRefresh() {
    this.setStageHeight();
  }

  setStageHeight() {
    let maxHeight = 0;

    Array.prototype.slice.call(this.slideItems).forEach((item) => {
      let height;
      const hiddenBlock = item.querySelector('[data-toggled-block]');

      if (hiddenBlock && !hiddenBlock.offsetHeight) {
        height = item.offsetHeight + hiddenBlock.children[0].offsetHeight;
      } else {
        height = item.offsetHeight;
      }

      if (height > maxHeight) maxHeight = height;
    });

    this.stage.style.height = `${maxHeight}px`;
  }

  findSlide(index) {
    if (index > this.slideItems.length) {
      index -= this.slideItems.length;
    }

    if (index === this.slideItems.length) return this.slideItems[index - this.slideItems.length];

    if (!this.slideItems[index]) {
      return this.slideItems[this.slideItems.length + index];
    }
    return this.slideItems[index];
  }

  move(index) {
    const pageHiddenBlock = this.selector.querySelector('[data-toggled-block]');

    if (index - this.state.current > 0) {
      this.stage.setAttribute('data-direction', 'forward');
    } else {
      this.stage.setAttribute('data-direction', 'backward');
    }

    if (this.selector.querySelector('.slider__item--current') && pageHiddenBlock) {
      slideUp(this.selector.querySelector('.slider__item--current [data-toggled-block]'));
    }

    this.slideItems[this.state.current].classList.remove('slider__item--current');
    this.slideItems[this.state.current].style.display = '';

    this.findSlide(this.state.current - 2).classList.remove('slider__item--before-prev');
    this.findSlide(this.state.current - 2).style.display = '';

    this.findSlide(this.state.current - 1).classList.remove('slider__item--prev');
    this.findSlide(this.state.current - 1).style.display = '';

    this.findSlide(this.state.current + 1).classList.remove('slider__item--next');
    this.findSlide(this.state.current + 1).style.display = '';

    this.findSlide(this.state.current + 2).classList.remove('slider__item--after-next');
    this.findSlide(this.state.current + 2).style.display = '';

    this.state.current = Array.prototype.slice.call(this.slideItems).indexOf(this.findSlide(index));

    this.slideItems[this.state.current].style.display = 'block';
    this.slideItems[this.state.current].classList.add('slider__item--current');

    pageHiddenBlock ? slideDown(this.selector.querySelector('.slider__item--current [data-toggled-block]')) : null; /* eslint-disable-line */

    const prevPrevSlide = this.findSlide(this.state.current - 2);
    const prevSlide = this.findSlide(this.state.current - 1);
    const nextSlide = this.findSlide(this.state.current + 1);
    const nextNextSlide = this.findSlide(this.state.current + 2);

    prevPrevSlide.style.display = 'block';
    prevPrevSlide.classList.add('slider__item--before-prev');

    prevSlide.style.display = 'block';
    prevSlide.classList.add('slider__item--prev');

    pageHiddenBlock ? slideUp(this.selector.querySelector('.slider__item--prev [data-toggled-block]')) : null; /* eslint-disable-line */

    nextSlide.style.display = 'block';
    nextSlide.classList.add('slider__item--next');

    nextNextSlide.style.display = 'block';
    nextNextSlide.classList.add('slider__item--after-next');
  }
}

export default PerfomanceSlider;
